var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscordFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(-994 -4042.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_discord_3069758",
    transform: "translate(994 4042.453)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "ellipse",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#8c9eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M116.939,141.694a11.727,11.727,0,0,0-5.459-2.094l-.263.511a10.711,10.711,0,0,1,5.181,2.627,17.07,17.07,0,0,0-16.384,0,10.943,10.943,0,0,1,5.181-2.627l-.263-.511a11.657,11.657,0,0,0-5.459,2.094s-2.793,3.886-3.274,11.514a10.534,10.534,0,0,0,7.1,3.137l.894-1.144a10.949,10.949,0,0,1-4.715-3.044,15.891,15.891,0,0,0,17.48,0,10.949,10.949,0,0,1-4.715,3.044l.894,1.144a10.534,10.534,0,0,0,7.1-3.137C119.732,145.58,116.939,141.694,116.939,141.694Zm-12.292,9.42a2.1,2.1,0,1,1,1.915-2.094A2.008,2.008,0,0,1,104.647,151.114Zm7.1,0a2.1,2.1,0,1,1,1.915-2.094A2.008,2.008,0,0,1,111.75,151.114Z",
    transform: "translate(-89.277 -129.058)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordFooter);
export default __webpack_public_path__ + "static/media/discordFooter.18ae438499f9dc6c5ae6766046eb1bf2.svg";
export { ForwardRef as ReactComponent };